var _path, _path2, _path3, _rect, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9403 31.6883H40.9933C40.1183 28.2993 38.3102 25.2237 35.7745 22.811C33.2389 20.3983 30.0773 18.7452 26.649 18.0395C23.2208 17.3338 19.6633 17.6039 16.3809 18.8191C13.0985 20.0342 10.2227 22.1457 8.08035 24.9136C5.938 27.6815 4.61498 30.9948 4.26162 34.477C3.90826 37.9593 4.53873 41.4708 6.0814 44.6127C7.62406 47.7545 10.0171 50.4006 12.9885 52.2504C15.9599 54.1001 19.3906 55.0793 22.8907 55.0767H43.9403C47.0417 55.0767 50.0162 53.8446 52.2093 51.6516C54.4024 49.4585 55.6345 46.484 55.6345 43.3825C55.6345 40.281 54.4024 37.3066 52.2093 35.1135C50.0162 32.9204 47.0417 31.6883 43.9403 31.6883Z",
    fill: "url(#paint0_linear_250_7187)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6574 58C15.6574 58 28.4574 51.6 28.4574 42V30.8L15.6574 26L2.85742 30.8V42C2.85742 51.6 15.6574 58 15.6574 58Z",
    fill: "url(#paint1_linear_250_7187)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12988 40.4619L14.6299 45.9619L23.1299 37.4619",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.8574,
    y: 17,
    width: 18,
    height: 38,
    rx: 2,
    fill: "url(#paint2_linear_250_7187)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.8574,
    cy: 49.4556,
    r: 1.5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_7187",
    x1: 15.1855,
    y1: 19.9995,
    x2: 48.5702,
    y2: 58.7687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8481FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_7187",
    x1: 15.6574,
    y1: 26,
    x2: 15.6574,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DF74",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_250_7187",
    x1: 44.8574,
    y1: 17,
    x2: 44.8574,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDevice);
export default __webpack_public_path__ + "static/media/CloudDevice.9448bfdaa5b795980ad625043b095e46.svg";
export { ForwardRef as ReactComponent };